
function ajaxResponseValidation(data) {
    var form = $(data).is("form") ? $(data) : $(data).find("form");
    if (form.length > 0) {
        var formId = "#" + form.attr("id");
        $(formId).removeData("validator");
        $(formId).removeData("unobtrusiveValidation");
        $.validator.unobtrusive.parse(formId);
    }
}

var XPortal = XPortal || {};
XPortal.Validation = (function () {
    var self = { debug: false };
    var data_validation = "unobtrusiveValidation";
    function getModelNameFor(validatorContext) {
        const modelName = $(validatorContext.currentForm).data("modelName");
        return modelName;
    };
    self.EnsureCustomValidation = function (xdata, fcode, xelement) {
        if (fcode && fcode.trim().length > 0) {
            var f = new Function('value', 'data', 'element', 'parent', 'form', 'xcontext', 'modelName', 'return ' + fcode);
            try {
                const frm = $(this.currentForm);
                const mname = getModelNameFor(this);
                const rx = f.call(this, xdata, xdata, xelement, frm, frm, this, mname);
                return rx;
            } catch (e) {//when validation didn't parsed properly - that issue of configuration     
                if (console) console.error(e, f);
                return false;
            }
        }
        return true;
    }
    function ensureMinMaxValuesValidation(value, min, max) {
        var result = true;
        value = value || "";
        var values = value.split("_#_");
        if (min != null && values.length < min)
            result = false;
        if (max != null && values.length > max)
            result = false;
        return result;
    }
    self.XChecked = function (xval, data, element, context, params) {
        var r = $(element).prop("checked");
        return r;
    };
    function ensureDynamicValidation(xdata, params, el) {
        return true;
    }

    //-- copy of unobtrusive --- needs to work with fields outside form
    function ensureControlEvents(xcontainer, xform) {
        function delegate(event) {
            if (console && self.debug) {
                console.log("control ensureControlEvents: ", event);
            }
            var validator = $.data(xform, "validator"), eventType = "on" + event.type.replace(/^validate/, "");
            validator = validator ? validator : xform.data("validator");
            if (!(validator)) return;
            var settings = validator.settings;
            if (settings[eventType] && !$(this).is(settings.ignore)) {

                var oel = validator.element;
                validator.element = function (el) {
                    return validateElement($(el), xform);
                };
                var valres = settings[eventType].call(validator, this, event);
                if ((eventType === "onfocusout") && !validator.checkable(this)) {
                    if (!(this.name in validator.submitted || !validator.optional(this))) validateElement($(this), xform);
                }
                validator.element = oel;
            };
        };
        $(xcontainer)
            .on("focusin.validate focusout.validate keyup.validate",
                ":text, [type='password'], [type='file'], select, textarea, [type='number'], [type='search'], " +
                "[type='tel'], [type='url'], [type='email'], [type='datetime'], [type='date'], [type='month'], " +
                "[type='week'], [type='time'], [type='datetime-local'], [type='range'], [type='color'], " +
                "[type='radio'], [type='checkbox'], [contenteditable], [type='button']", delegate)

            // Support: Chrome, oldIE
            // "select" is provided as event.target when clicking a option
            .on("click.validate", "select, option, [type='radio'], [type='checkbox']", delegate);
    }
    function unobtrusiveParseElement($this, xform) {
        $this = $($this);
        if (!$this.attr("data-val-xdynamic")) $this.attr("data-val-xdynamic", "true");
        var element = $this[0];
        var form = xform[0], valInfo, rules, messages;

        valInfo = xform.data(data_validation);
        valInfo.options.rules[element.name] = rules = {};
        valInfo.options.messages[element.name] = messages = {};

        $.each($.validator.unobtrusive.adapters, function (ai, aObj) {
            var prefix = "data-val-" + aObj.name,
                message = $this.attr(prefix),
                paramValues = {};

            if (message !== undefined) {  // Compare against undefined, because an empty message is legal (and falsy)
                prefix += "-";

                $.each(aObj.params, function (pi, pObj) {
                    paramValues[pObj] = $this.attr(prefix + pObj);
                });
                this.adapt({ element: element, form: form, message: message, params: paramValues, rules: rules, messages: messages });
            }
        });

        $.extend(rules, { "__dummy__": true });

        ///--add validation messages container       
        if ($.map(rules, function (n, i) { return i; }).length > 1) {
            var summaryClass = 'xfield-validation', $fldWrapper = !xform.hasClass('grid-cell-validation-form') ? $this.closest('[class*= "col-"]') : $this.closest('td');
            var $vsm = $fldWrapper.find('.' + summaryClass);
            if (!$vsm.length) {
                $vsm = $('<span />', { class: summaryClass, "data-valmsg-for": escapeAttributeValue(element.name), "data-valmsg-replace": true });
                $vsm.appendTo($fldWrapper);
            };
        };
        //--
        self.initTooltips($('.xfield-validation'));
        return rules;
    }

    self.initTooltips = function($element) {
        $element.kendoTooltip({
            position: 'bottom',
            content: function (e) {
                const $target = $(e.sender.element);
                const html = $target.html();
                
                // Prevent showing the tooltip if inner width is <= parent width
                if ($target[0].scrollWidth <= $target[0].clientWidth) {
                    return;
                }

                return html;
            },
            show: function(e) {
                const $target = $(e.sender.element);
                let content = '';
                const tooltipElement = this.popup.element;
                const tooltipWidth = $target.outerWidth();
                const targetOffset = $target.offset();
                const targetCenterX = targetOffset.left + ($target.outerWidth() / 2);
                const tooltipHalfWidth = tooltipWidth / 2;

                if ($target[0].scrollWidth > $target[0].clientWidth) {
                    content = $target.html(); //duplicate popup content for ajax cases
                }

                // Set tooltip dimensions and position
                tooltipElement.css({
                    'width': `${tooltipWidth}px`
                });

                tooltipElement.parent('.k-animation-container').css({
                    'width': `${tooltipWidth}px`,
                    'left': `${targetCenterX - tooltipHalfWidth}px`
                });

                tooltipElement.find('.k-tooltip-content').html(content);

                // Center the k-callout (tooltip arrow)
                const $calloutElement = tooltipElement.find('.k-callout');
                const calloutHalfWidth = $calloutElement.outerWidth() / 2;
                $calloutElement.css('left', `${tooltipWidth / 2 - calloutHalfWidth}px`);

                tooltipElement.addClass('validation-tooltip');
            }
        });
    }

    function checkElement(element, xfrm) {
        var jvalidator = xfrm.validate();
        element = jvalidator.clean(element);
        var rules = jvalidator.settings.rules[$(element)[0].name],
            rulesCount = $.map(rules, function (n, i) { return i; }).length,
            dependencyMismatch = false,
            val = jvalidator.elementValue(element),
            result, method, rule, normalizer;

        if (rules && rules.hasOwnProperty('xcustom')) {
            var cstmMethods = rules['xcustom'];
            var methods = cstmMethods && cstmMethods.length ? jQuery.parseJSON(cstmMethods) : [];
            var msgs = jvalidator.settings.messages[$(element)[0].name];
            var messages = jQuery.parseJSON(msgs.xcustom);
            for (let i = 0; i < methods.length; i++) {
                jvalidator.settings.rules[$(element)[0].name]['xcustom' + i] = methods[i];
                jvalidator.settings.messages[$(element)[0].name]['xcustom' + i] = messages[i];
                $.validator.methods['xcustom' + i] = $.validator.methods['xcustom'];
            }
            delete jvalidator.settings.rules[$(element)[0].name].xcustom;
            delete jvalidator.settings.messages[$(element)[0].name].xcustom;
            rules = jvalidator.settings.rules[$(element)[0].name];
        }

        for (method in rules) {
            rule = { method: method, parameters: rules[method] };
            try {
                result = $.validator.methods[method].call(jvalidator, val, element, rule.parameters);

                if (typeof result === 'function') {
                    result = result.call(jvalidator, val, element, rule.parameters);
                }

                if (result === "dependency-mismatch" && rulesCount === 1) {
                    dependencyMismatch = true;
                    continue;
                }
                dependencyMismatch = false;

                if (result === "pending") {
                    jvalidator.toHide = jvalidator.toHide.not(jvalidator.errorsFor(element));
                    return;
                }

                if (!result) {
                    jvalidator.formatAndAdd(element, rule);
                    return false;
                }
            } catch (e) {
                if (jvalidator.settings.debug && window.console) {
                    console.log("Exception occurred when checking element " + element.id + ", check the '" + rule.method + "' method.", e);
                }
                if (e instanceof TypeError) {
                    e.message += ".  Exception occurred when checking element " + element.id + ", check the '" + rule.method + "' method.";
                }
                throw e;
            }
        }
        if (dependencyMismatch) return;
        if (jvalidator.objectLength(rules)) jvalidator.successList.push(element);
        return true;
    }

    function validateElement($this, xfrm, doNotDisplayErrors) {
        //if (console) console.log("validate element", $this, xfrm);
        var jvalidator = xfrm.validate();
        $this = $this && $this.length > 0 ? $this[0] : $this;
        jvalidator.prepareElement($this);
        jvalidator.currentElements = $($this);
        var rs = true;
        rs = rs && checkElement($this, xfrm);//validate ot of the form
        if (rs) {
            jvalidator.invalid[checkElement.name] = false;
            jvalidator.showLabel($this);
        }
        else jvalidator.invalid[checkElement.name] = true;
        if (!jvalidator.numberOfInvalids())
            jvalidator.toHide = jvalidator.toHide.add(jvalidator.containers);
        if (!doNotDisplayErrors)
            jvalidator.showErrors();
        return rs;
    }

    function validationInfo(form, onErrorHandler) {
        var $form = $(form),
            result = $form.data(data_validation),
            onResetProxy = $.proxy(onReset, form),
            defaultOptions = $.validator.unobtrusive.options || {},
            execInContext = function (name, args) {
                var func = defaultOptions[name];
                func && $.isFunction(func) && func.apply(form, args);
            };
        if (result) return result;
        result = {
            options: {  // options structure passed to jQuery Validate's validate() method
                ignore: "[data-role='combobox'] input.k-input, [data-role='dropdownlist'] input.k-input, [data-role='autocomplete'] input.k-input",
                errorClass: defaultOptions.errorClass || "input-validation-error",
                errorElement: defaultOptions.errorElement || "span",
                errorPlacement: onErrorHandler ? onErrorHandler : function () {
                    onError.apply(form, arguments);
                    execInContext("errorPlacement", arguments);
                },
                invalidHandler: function () {
                    onErrors.apply(form, arguments);
                    execInContext("invalidHandler", arguments);
                },
                messages: {},
                rules: {},
                success: function () {
                    onSuccess.apply(form, arguments);
                    execInContext("success", arguments);
                }
            },
            attachValidation: function () {
                $form
                    .off("reset." + data_validation, onResetProxy)
                    .on("reset." + data_validation, onResetProxy)
                    .validate(this.options);
            },
            validate: function () {  // a validation function that is called by unobtrusive Ajax
                $form.validate();
                return $form.valid();
            }
        };
        $form.data(data_validation, result);
        return result;
    }

    function escapeAttributeValue(value) {
        return value.replace(/([!"#$%&'()*+,./:;<=>?@\[\\\]^`{|}~])/g, "\\$1");
    }

    function onReset(event) {  // 'this' is the form element
        var $form = $(this),
            key = '__jquery_unobtrusive_validation_form_reset';
        if ($form.data(key)) {
            return;
        }
        // Set a flag that indicates we're currently resetting the form.
        $form.data(key, true);
        try {
            $form.data("validator").resetForm();
        } finally {
            $form.removeData(key);
        }

        $form.find(".validation-summary-errors")
            .addClass("validation-summary-valid")
            .removeClass("validation-summary-errors");
        $form.find(".field-validation-error")
            .addClass("field-validation-valid")
            .removeClass("field-validation-error")
            .removeData("unobtrusiveContainer")
            .find(">*")  // If we were using valmsg-replace, get the underlying error
            .removeData("unobtrusiveContainer");
    }

    function onError(error, inputElement) {  // 'this' is the form element        
        var container = $(this).parent().find("[data-valmsg-for='" + escapeAttributeValue(inputElement[0].name) + "']"),
            replaceAttrValue = container.attr("data-valmsg-replace"),
            replace = replaceAttrValue ? $.parseJSON(replaceAttrValue) !== false : null;

        container.removeClass("field-validation-valid").addClass("field-validation-error");
        error.data("unobtrusiveContainer", container);

        if (replace) {
            container.empty();
            error.removeClass("input-validation-error").appendTo(container);
        }
        else {
            error.hide();
        }
    }

    function onErrors(event, validator) {  // 'this' is the form element        
        var container = $(this).find("[data-valmsg-summary=true]"),
            list = container.find("ul");

        if (list && list.length && validator.errorList.length) {
            list.empty();
            container.addClass("validation-summary-errors").removeClass("validation-summary-valid");

            $.each(validator.errorList, function () {
                $("<li />").html(this.message).appendTo(list);
            });
        }
    }

    function onSuccess(error) {  // 'this' is the form element       
        var container = error.data("unobtrusiveContainer");
        if (!container) return;
        var replaceAttrValue = container.attr("data-valmsg-replace");
        var replace = replaceAttrValue ? $.parseJSON(replaceAttrValue) : null;

        container.addClass("field-validation-valid").removeClass("field-validation-error");
        container.siblings(".input-validation-error").removeClass("input-validation-error").removeClass("field-validation-error");
        error.removeData("unobtrusiveContainer");
        if (replace) container.empty();
    }
    // -- end of ---unobtrusive copy

    function registerCustomValidators() {
        jQuery.validator.addMethod('xcustom', function (value, element, params) {
            var r = self.EnsureCustomValidation.apply(this, [value, params, element]);
            return r;
        });
        $.validator.unobtrusive.adapters.addSingleVal("xcustom", "pattern");

        jQuery.validator.addMethod('xdynamic', function (value, element, params) {
            var r = ensureDynamicValidation.apply(this, [value, params, element]);
            return r;
        });
        XPortal.GRecaptcha.InitJQueryValidators();

        $.validator.unobtrusive.adapters.addSingleVal("xdynamic", "pattern");

        jQuery.validator.addMethod("minvalues", function (value, element, params) {
            return ensureMinMaxValuesValidation(value, params, null);
        });
        jQuery.validator.addMethod("maxvalues", function (value, element, params) {
            return ensureMinMaxValuesValidation(value, null, params);
        });
        jQuery.validator.addMethod("minmaxvalues", function (value, element, params) {
            return ensureMinMaxValuesValidation(value, params[0], params[1]);
        });
        $.validator.unobtrusive.adapters.addMinMax("minmax", "minvalues", "maxvalues", "minmaxvalues", "min", "max");
    }

    self.Init = function () {
        //register custom validation rule /unobtrusive & normal
        registerCustomValidators();
        self.initTooltips($('.xfield-validation'));
    };

    self.ParseElementsIn = function (xcontainer, xform, onErrorHandler) {
        // parse validation attributes for all elements in container (+relate them to form)
        if (!xform || !xform.length) return;
        var info = validationInfo(xform, onErrorHandler);
        $(xcontainer).find("[data-val=true]").each(function () {
            unobtrusiveParseElement(this, xform);
        });
        if (info) info.attachValidation();
        ensureControlEvents($(xcontainer), xform);
        XPortal.GRecaptcha.RenderGRecaptcha();
        return info;
    };

    self.ValidareElements = function (xcontainer, xform) {
        //validate all elements in container...(parse them, in case when some don't yet parsed?)
    };

    self.ValidateElement = function (xelement, xform, doNotDisplayErrors) {
        //validate an particular element (parse it, in case when doesn't yet parsed?)\
        return validateElement(xelement, xform, doNotDisplayErrors);
    };

    self.Init();

    return self;
})();